import APIController from '../core-api-controller';

export const fetchChargesApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/charges${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchChargeVouchersApi = ({ chargeId = '', paramsStr = '', paramsObj = {} }) => {
  const path = `${APIController.endpointApi}/charges/${chargeId}/vouchers${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchChargeAvailableLabPanelsApi = ({ chargeId = '' }) => {
  const path = `${APIController.endpointApi}/charges/${chargeId}/fetch_available_panels`;
  return APIController.getApiCallback(path);
};
